/**
 * @fileoverview
 * A jQuery plugin to add auto expandability to textarea boxes.
 * Usage: layout a textarea with a sepcific class or ID, then 
 * use a jQuery selector to grab the textarea and run the function:
 * jQuery(".mytextareaclass").autoBoxResize(); (good for multiple boxes with same class)
 * jQuery("#mytextareaID").autoBoxResize();
 * 
 */

(function($) {    
  $.fn.autoBoxResize = function(minHeight, maxHeight) {  
      this.each(function() {  
        if (this.nodeName.toLowerCase() != "textarea") return;  
        $(this).css({"display": "block", "overflow": "hidden", "padding-top": "0", "padding-bottom": "0"});
        this.expandMin = minHeight || $(this).height();  
        expandBox(this);  
        if (!this.isInit) {
          this.isInit = true;                                        
          $(this).bind("keyup focus", expandBox);  
        }  
      });  
      return this;  
  };

  function expandBox(e){
    var elem = e.target || e;
    //elem.style.height = elem.expandMin+"px";
    var h = Math.max(elem.expandMin, elem.scrollHeight);
    elem.style.overflow = (elem.scrollHeight > h ? "auto" : "hidden");  
    elem.style.height = h + "px";
    return true;
  }                
})(jQuery);